var VehicleService = function ($q, apiConstants, modelFactoryService) {
    var Vehicle = function (params) {
        if (params) {
            params.id && this.setId(params.id);
            params.model && this.setModel(params.model);
            params.year && this.setYear(params.year);
            params.transmission && this.setTransmission(params.transmission);
            params.train && this.setDriveTrain(params.train);
            params.vin && this.setVinNumber(params.vin);
            params.engine && this.setEngine(params.engine);
            params.make && this.setManufacturer(params.make);
            params.maintenance && this.setMaintenance(params.maintenance);
        }
    };
    
    /*
     * setTelematicsData
     *
     * @description
     * Set vehicle data from Telematics call of the current vehicle
     */
    Vehicle.prototype.setTelematicsData = function (data){
        this._telematicsData = data;
    };
     /*
     * getTelematicsData
     *
     * @description
     * Get vehicle data from Telematics call of the current vehicle
     */
    Vehicle.prototype.getTelematicsData = function (){
        return this._telematicsData;
    };
    /*
     * getTelematicsOdometer
     *
     * @return {Int} telematics odometer of the current vehicle
     *
     * @description
     * Gets telematics odometer reading of the current vehicle
     */
    Vehicle.prototype.getTelematicsOdometer = function(){
        if (this._telematicsData){
            return this._telematicsData.lastOdometer;
        }
        return null;
    };
    /*
     * setManufacturer
     *
     * @param {String} manufacturer of the current vehicle
     *
     * @return {Vehicle} self instance
     *
     * @description
     * Set the manufacturer of the new wehicle
     */
    Vehicle.prototype.setManufacturer = function (manufacturer) {
        this._manufacturer = manufacturer;
        return this;
    };
    /*
     * getId
     *
     * @return {String} manufacturer of the current vehicle
     *
     * @description
     * Gets manufacturer of the current vehicle
     */
    Vehicle.prototype.getManufacturer = function () {
        return this._manufacturer;
    };
    /*
     * setId
     *
     * @param {String} id of the current vehicle
     *
     * @return {Vehicle} self instance
     *
     * @description
     * Set the id of the new wehicle
     */
    Vehicle.prototype.setId = function (id) {
        this._id = id;
        return this;
    };
    /*
     * getId
     *
     * @return {String} id of the current vehicle
     *
     * @description
     * Gets id of the current vehicle
     */
    Vehicle.prototype.getId = function () {
        return this._id;
    };
    /*
     * setModel
     *
     * @param {String} model of the current vehicle
     *
     * @return {Vehicle} self instance
     *
     * @description
     * Set the model of the new wehicle
     */
    Vehicle.prototype.setModel = function (model) {
        this._model = model;
        return this;
    };
    /*
     * getModel
     *
     * @return {String} model of the current vehicle
     *
     * @description
     * Gets model of the current vehicle
     */
    Vehicle.prototype.getModel = function () {
        return this._model;
    };
    /*
     * setYear
     *
     * @param {String} year of the current vehicle
     *
     * @return {Vehicle} self instance
     *
     * @description
     * Set the year of the new wehicle
     */
    Vehicle.prototype.setYear = function (year) {
        this._year = year;
        return this;
    };
    /*
     * getYear
     *
     * @return {String} year of the current vehicle
     *
     * @description
     * Gets year of the current vehicle
     */
    Vehicle.prototype.getYear = function () {
        return this._year;
    };
    /*
     * setTransmission
     *
     * @param {String} transmission of the current vehicle
     *
     * @return {Vehicle} self instance
     *
     * @description
     * Set the transmission of the new wehicle
     */
    Vehicle.prototype.setTransmission = function (transmission) {
        this._transmission = transmission;
        return this;
    };
    /*
     * getTransmission
     *
     * @return {String} transmissioin of the current vehicle
     *
     * @description
     * Gets transmissioin of the current vehicle
     */
    Vehicle.prototype.getTransmission = function () {
        return this._transmission;
    };
    /*
     * setDriveTrain
     *
     * @param {String} drive train of the current vehicle
     *
     * @return {Vehicle} self instance
     *
     * @description
     * Set the drive train of the new wehicle
     */
    Vehicle.prototype.setDriveTrain = function (driveTrain) {
        this._driveTrain = driveTrain;
        return this;
    };
    /*
     * getDriveTrain
     *
     * @return {String} drive train
     *
     * @description
     * Gets drive train of the current vehicle
     */
    Vehicle.prototype.getDriveTrain = function () {
        return this._driveTrain;
    };
    /*
     * setEngine
     *
     * @param {String} engine of the current vehicle
     *
     * @return {Vehicle} self instance
     *
     * @description
     * Set the engine of the new wehicle
     */
    Vehicle.prototype.setEngine = function (engine) {
        this._engine = engine;
        return this;
    };
    /*
     * getEngine
     *
     * @return {String} engine
     *
     * @description
     * Gets engine of the current vehicle
     */
    Vehicle.prototype.getEngine = function () {
        return this._engine;
    };
    /*
     * setVinNumber
     *
     * @param {String} vin number of the current vehicle
     *
     * @return {Vehicle} self instance
     *
     * @description
     * Set the vin number of the new wehicle
     */
    Vehicle.prototype.setVinNumber = function (vinNumber) {
        this._vinNumber = vinNumber;
        return this;
    };
    /*
     * getEngine
     *
     * @return {String} vin number
     *
     * @description
     * Gets vin number of the current vehicle
     */
    Vehicle.prototype.getVinNumber = function () {
        return this._vinNumber;
    };
    /*
     * getModelRepresentation
     *
     * @return {String} vehicle model in format vehicle model name
     *   and year of manufacturing
     */
    Vehicle.prototype.getModelRepresentation = function () {
        var make = this.getManufacturer(),
            year = this.getYear(),
            model = this.getModel();
        return (year ? year.name : '') + ' ' + (make ? make.name : '') + ' ' + (model ? model.name : '')
    };
    /*
     * getSpecification
     *
     * @return {String} vehicle specification
     */
    Vehicle.prototype.getSpecification = function () {
        var transmission = this.getTransmission(),
            engine = this.getEngine(),
            driveTrain = this.getDriveTrain();
        return (transmission ? transmission.name : '') + ' ' +
            (engine ? engine.name : '') + ' ' +
            (driveTrain ? driveTrain.name : '');
    };
    /*
     * setMaintenance
     */
    Vehicle.prototype.setMaintenance = function (value) {
        this._maintenance = value;
    };
    /*
     * getMaintenance
     */
    Vehicle.prototype.getMaintenance = function () {
        return this._maintenance;
    };

    /*
     * setCurrentMaintenanceInterval
     *
     * @param {number} current maintenance interval
     *
     * @description
     * sets current maintenance period
     */
    Vehicle.prototype.setCurrentMaintenanceInterval = function (interval) {
        this._maintenanceInterval = interval;
    };
    /*
     * getCurrentMaintenanceInterval
     *
     * @return {number} current maintenance interval
     *
     * @description
     * gets current maintenance period
     */
    Vehicle.prototype.getCurrentMaintenanceInterval = function (interval) {
        return this._maintenanceInterval;
    };

    /*
     * createNewVehicle
     *
     * @param {Object} the data to fill into new vehicle properties
     *
     * @return {Vehicle} instance of the Vehicle class
     *
     * @description
     * Static method that creates new instance of the Vehicle class
     * according to passed params.
     */
    Vehicle.createNewVehicle = function (params) {
        return new Vehicle(params);
    };

    /*
     * extend
     *
     * @param {Object} vehicle that was created by model factory service
     *
     * @return {Object} instance of the Vehicle class
     *
     * @descripton
     * Extends vehicle that created by model factory service by vehicle
     * class
     */
    Vehicle.extend = function (vehicleFactory) {
        if (!vehicleFactory) {
            return undefined;
        } else {

            if (_.isObject(vehicleFactory))
                vehicleFactory = _.create(function () {
                }, vehicleFactory);

            for (var key in Vehicle.prototype) {
                if (Vehicle.prototype.hasOwnProperty(key)) {
                    vehicleFactory.__proto__[key] = Vehicle.prototype[key];
                }
            }
            Vehicle.apply(vehicleFactory, arguments);
            return vehicleFactory;
        }
    };

    //setVehicleDetails
    //
    //@param {object} - vehicle model
    //
    //@return {object} - promise that resolves vehicle model
    //
    //@description
    //By default api response returns vehicle object with previews of the some
    //properies such as make, year, transmission, engine and drive train.
    //To work with vehicle object it is required to get all information about
    //described properties. This method perfomrs request to get every property
    //and updates information in vehicle model.
    Vehicle.setVehicleDetails = function (vehiclePreview) {
        var vehicle = this.extend(vehiclePreview)
        var deferred = $q.defer();
        $q.all([
            modelFactoryService.createModel(vehicle.make, apiConstants.METHODS).getManufacturer(),
            modelFactoryService.createModel(vehicle.year, apiConstants.METHODS).getYear(),
            modelFactoryService.createModel(vehicle.model, apiConstants.METHODS).getModel(),
            modelFactoryService.createModel(vehicle.transmission, apiConstants.METHODS).getTransmission(),
            modelFactoryService.createModel(vehicle.engine, apiConstants.METHODS).getEngine(),
            modelFactoryService.createModel(vehicle.train, apiConstants.METHODS).getDriveTrain(),
        ]).then(function (res) {
            vehicle.setManufacturer(res[0]);
            vehicle.setYear(res[1]);
            vehicle.setModel(res[2]);
            vehicle.setTransmission(res[3]);
            vehicle.setEngine(res[4]);
            vehicle.setDriveTrain(res[5]);
            deferred.resolve(vehicle);
        }).catch(function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    };

    // distributing service methods
    return {
        getClass: Vehicle,
        createNewVehicle: Vehicle.createNewVehicle,
        extend: Vehicle.extend,
        setVehicleDetails: Vehicle.setVehicleDetails
    };
};
VehicleService.$inject = ['$q', 'ApiConstants', 'modelFactoryService'];
module.exports = VehicleService;
